<template>
  <el-form-item :label="label" :prop="name" :rules="getRules()">
    <el-input
      v-on="listeners"
      v-bind="$attrs"
      :id="name"
      auto-complete="new-password"
      :placeholder="placeholder || label"
      :disabled="disabled"
      :data-testid="testId || name"
      :class="[passwordIcon ? 'password-input-wrap' : '', typePasswordClassName]"
      ref="myInput"
    />
    <slot></slot>
  </el-form-item>
</template>

<script>
import { validateEmail } from '@/util/validation';

export default {
  name: 'inputTemplate',
  props: { name: String, label: String, placeholder: String, disabled: Boolean, testId: String, rules: String },
  data() {
    return {
      focus: false,
      emailRules: [
        {
          required: true,
          message: this.$t('common.formValidation.emailReq'),
          trigger: 'blur'
        },
        {
          validator: validateEmail,
          trigger: 'blur'
        }
      ],
      inputRules: {
        required: true,
        message: this.$t('common.formValidation.common'),
        trigger: 'blur'
      },
      typeValuePassword: false
    };
  },
  computed: {
    passwordIcon() {
      if (this.$attrs.hasOwnProperty('show-password') && this.$attrs['type'] === 'password') {
        return true;
      }
    },
    typePasswordClassName() {
      return this.typeValuePassword ? 'password-input' : 'text-input';
    },
    listeners() {
      return Object.assign({}, this.$listeners, {
        input: event => this.$emit('input', event),
        focus: event => {
          this.focus = true;
          this.$nextTick(() => {
            this.typeValuePassword = event.target.attributes.type.value === 'password' ? true : false;
          });
        },
        blur: event => (this.focus = false)
      });
    }
  },
  methods: {
    getRules() {
      switch (this.rules) {
        case 'email':
          return this.emailRules;
        case 'input':
          return this.inputRules;
        default:
          return null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/input.scss';
</style>
<style lang="scss">
.password-input-wrap.password-input {
  .el-icon-view {
    &::before {
      content: '';
      display: inline-block;
      background: url(~@/assets/images/icon_eye_close.png) no-repeat;
      width: 18px;
      height: 18px;
      background-size: cover;
      position: relative;
      top: 3px;
    }
  }
}
.password-input-wrap.text-input {
  .el-icon-view {
    &::before {
      width: 16px;
      height: 16px;
      content: '\e6ce';
    }
  }
}
</style>
